document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-terms-checkbox]') || event.target.checked) return;
  fetch(`${window.routes?.root || '/'}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Terms accepted': '', 'Terms accepted at': '', 'Terms version': '' } }) });
});

document.addEventListener('click', async (event) => {
    const button = event.target.closest('button[name="checkout"], a[href$="/checkout"]');
    if (!button) return;
    const scope = button.closest('.drawer__footer, .cart__footer, cart-notification') || document;
    const box = scope.querySelector('[data-terms-checkbox]') || document.querySelector('[data-terms-checkbox]');
    if (!box?.checked) {
      event.preventDefault(); event.stopImmediatePropagation();
      const error = scope.querySelector('[data-terms-error]') || document.querySelector('[data-terms-error]');
      if (error) { error.hidden = false; error.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return;
    }
    event.preventDefault(); event.stopImmediatePropagation();
    button.disabled = true;
    try {
      await fetch(`${window.routes?.root || '/'}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Terms accepted': 'Yes', 'Terms accepted at': new Date().toISOString(), 'Terms version': 'Terms of Hire page' } }) });
      window.location.assign('/checkout');
    } catch (_) { button.disabled = false; }
}, true);
